<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="7" class="main-part d-none d-md-none d-lg-flex">
          <div class="d-flex">
            <v-img src="@/assets/logo-projeto.png" contain></v-img>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="login-part d-flex align-center justify-center">
          <v-row no-gutters class="align-start">
            <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                    <v-form lazy-validation v-model="valid" ref="form">
                      <v-container>
                        <v-row class="flex-column">
                          <v-col>
                            <p class="login-slogan text-center font-weight-medium my-10">Redefinição de Senha</p>
                          </v-col>
                          <v-form
                            ref="log"
                            v-model="valid"
                            lazy-validation
                          >
                            <v-col>
                              <v-text-field
                                id="password"
                                ref="password"
                                v-model="password"
                                :rules="passRules"
                                single-line
                                type="password"
                                label="Nova Senha"
                                required
                              ></v-text-field>
                              <v-text-field
                                id="passwordConfirm"
                                ref="passwordConfirm"
                                v-model="passwordConfirm"
                                :rules="passConfirmRules"
                                type="password"
                                label="Confirme a Nova Senha"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                class="text-capitalize"
                                large
                                block
                                color="primary"
                                :disabled="((this.password.length < 6 || this.passwordConfirm.length < 6) || (this.password !== this.passwordConfirm))"
                                @click.prevent="save">
                                Redefinir Senha
                              </v-btn>
                            </v-col>
                          </v-form>
                        </v-row>
                      </v-container>
                    </v-form>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-footer v-if="false">
                <div class="primary--text">© 2014-2020 <a href="https://flatlogic.com/" class="text-decoration-none">Flatlogic</a>, LLC. All rights reserved.</div>
              </v-footer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      token: {
        hash: '',
        validate: '',
        usuario: {
          senha: ''
        }
      },
      valid: false,
      password: '',
      passwordConfirm: '',
      passConfirmRules: [
        v => !!v || 'Confirmação da senha é obrigatório',
        v => v.length >= 6 || 'Mínimo de 6 caracteres',
        v => v === this.password || 'Verifique se digitou corretamente',
      ],
      passRules: [
        v => !!v || 'Senha é obrigatória',
        v => v.length >= 6 || 'Mínimo de 6 caracteres'
      ],
    };
  },
  methods: {
    save() {
      if(this.password === this.passwordConfirm) {
        this.token.usuario.senha = this.password;
        this.token.hash = this.$route.query.hash;
        this.$store.dispatch("auth/novaSenha", this.token).then(() => {
          this.$router.push({name: 'Login'});
        });
      }
      return;
    },
  },
};
</script>

<style src="./NovaSenha.scss" lang="scss"/>
